import { create } from "zustand"

interface UtilityStore {
  stopAllVoiceItemsCounter: number
  stopAllVoiceItems: () => void
}

export const useUtilityStore = create<UtilityStore>((set, get) => ({
  stopAllVoiceItemsCounter: 0,
  stopAllVoiceItems: () =>
    set({
      stopAllVoiceItemsCounter: get().stopAllVoiceItemsCounter + 1,
    }),
}))
